module.exports = __webpack_public_path__ + "img/news_list_0.62d15896.jpg";